import numeral from 'numeral'

export const tableCellFormat = (
  value: string | null | number,
  type: 'number' | 'dollars' | 'miles' | 'kilometers' | 'percentage' | string
): string | number => {
  if (value === null) return ''

  const numberValue =
    typeof value === 'string' ? parseFloat(value.replace('$', '')) : value

  if (type === 'dollars') {
    return numeral(numberValue).format('$0,0[.]00')
  }

  if (type === 'kilometers' || type === 'miles') {
    return `${numeral(numberValue).format('0,0[.]0')} ${
      type === 'miles' ? 'mi' : 'km'
    }`
  }

  if (type === 'percentage') {
    return `${numeral(numberValue).format('0')}%`
  }

  return value
}
